import React, { Component } from 'react';
import { css } from 'react-emotion';
import { withRouter } from 'react-router';

const bgImg = css({
  position: 'absolute',
  width: '100%',
  height: '100%',
  background:
    'url(https://www.reactiongifs.us/wp-content/uploads/2015/04/nothing_to_see_here_naked_gun.gif) no-repeat center center fixed',
  '-webkit-background-size': 'cover',
  '-moz-background-size': 'cover',
  '-o-background-size': 'cover',
  backgroundSize: 'cover',
  backgroundColor: '#000',
  opacity: '.8',
  filter: 'alpha(opacity=50)',
});

const content = css({
  fontFamily: "'Avenir-Next,Avenir',Helvetica,sans-serif",
  color: '#fff',
  backgroundColor: 'none',
  zIndex: 2,
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
});

const h1Style = css({
  fontSize: 160,
  marginBottom: 0,
  marginTop: 0,
  '@media only screen and (max-width: 480px)': {
    fontSize: 120,
  },
});

const h2Style = css({
  marginTop: 0,
  maxWidth: 700,
  fontSize: 30,
  width: '90%',
});

const pStyle = css({
  textAlign: 'left',
  paddingBottom: 32,
});

const btn = css({
  cursor: 'pointer',
  display: 'inline-block',
  border: '1px solid #aaa',
  borderRadius: '40px!important',
  padding: '15px 30px',
  marginRight: 15,
  marginBottom: 10,
  '&:hover': {
    color: '#e2e2e2',
    background: 'rgba(255,255,255,0.10)',
  },
  '@media only screen and (max-width: 480px)': {
    backgroundColor: 'white',
    color: '#444444',
    width: '100%',
  },
});

@withRouter
export default class FourOhFourPage extends Component {
  returnHome = () => {
    const { router } = this.props;
    router.push(`/projects`);
  };

  reportProblem = () => {
    const email = 'support@planz.dev';
    window.location.href = `mailto:${email}`;
  };

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <div className={content}>
            <div className="col-lg-12" />
            <div className="col-lg-12">
              <h1 className={h1Style}>404</h1>
              <h2 className={h2Style}>
                Oops, the page you're looking for does not exist.
              </h2>
              <p className={pStyle}>
                You may want to head back to the homepage.
                <br />
                If you think something is broken, report the problem.
                <br />
              </p>
              <span className={btn} onClick={() => this.returnHome()}>
                RETURN HOME
              </span>
              <span className={btn} onClick={() => this.reportProblem()}>
                REPORT PROBLEM
              </span>
            </div>
          </div>
        </div>
        <div className={bgImg} />
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/public/404.js